export const pageSizeWhenLoadingEverything = 500;

export interface PageRequest {
  first: number;
  offset: number;
}

export type PageQuery = {
  first: string;
  offset: string;
};

export interface PageOf<T> {
  items: T[];
  totalCount: number;
}

export function toPageQuery(page: PageRequest): PageQuery {
  return { first: String(page.first), offset: String(page.offset) };
}

export async function fetchEveryPage<T>(
  fetchPage: (page: PageQuery) => Promise<PageOf<T>>,
  cancelled?: AbortSignal,
): Promise<T[]> {
  const items: T[] = [];

  for (let offset = 0; !cancelled?.aborted; offset += pageSizeWhenLoadingEverything) {
    const page = await fetchPage(toPageQuery({ first: pageSizeWhenLoadingEverything, offset }));
    items.push(...page.items);

    if (page.items.length === 0 || items.length >= page.totalCount) {
      return items;
    }
  }

  return items;
}
